import UpdateStrip from "./components/UpdateStrip";
import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import FlashStream from "./components/FlashStream";
import Timeline from "./components/Timeline";
import QuoteFiles from "./components/QuoteFiles";
import TopicVolumes from "./components/TopicVolumes";
import Dossier from "./components/Dossier";
import EntryDownload from "./components/EntryDownload";
import Disclaimer from "./components/Disclaimer";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#faf5eb] text-[#1a160e]">
      <UpdateStrip />
      <Masthead />
      <main>
        <Hero />
        <FlashStream />
        <Timeline />
        <QuoteFiles />
        <TopicVolumes />
        <Dossier />
        <EntryDownload />
        <Disclaimer />
      </main>
      <Footer />
    </div>
  );
}